import React, { createContext, useContext, useState, ReactNode } from 'react';

interface AuthContextType {
  isAuthenticated: boolean;
  userRole: string | null;
  token: string | null;
  login: (token: string, role: string, name: string) => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [isAuth, setIsAuth] = useState<boolean>(false);
  const [token, setToken] = useState<string | null>(localStorage.getItem('authToken'));
  const [role, setRole] = useState<string | null>(localStorage.getItem('userRole'));
  const [name, setName] = useState<string | null>(localStorage.getItem('userName'));

  const login = (newToken: string, role: string, name: string) => {
    setToken(newToken);
    setRole(role.toString());
    setName(name);
    setIsAuth(true);
    localStorage.setItem('authToken', newToken);
    localStorage.setItem('userRole', role.toString());
    localStorage.setItem('userName', name);
  };

  const logout = () => {
    setToken(null);
    localStorage.removeItem('authToken');
    setRole(null);
    localStorage.removeItem('userRole');
    localStorage.removeItem('userName');
    setIsAuth(false);
  };

  return (
    <AuthContext.Provider
      value={{ isAuthenticated: !!token, userRole: role, token, login, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
